import {
  GetActivitiesSections_getActivitiesSections_components_ActivitiesCategoriseResponseComponent_properties,
  GetActivitiesSections_getActivitiesSections_components_ActivitiesCategoriseResponseComponent_properties_interactiveResponseCategorise_items,
  GetActivitiesSections_getActivitiesSections_components_ActivitiesCategoriseResponseComponent_properties_interactiveResponseCategorise_categories,
} from 'approot/activity-builder/__generated__/GetActivitiesSections';
import { ComponentInteractiveResponseCategorise } from '../../component.constants';
import { DropItem } from 'approot/activity-builder/components/shared/interactive-drag-drop/interactive-drag-drop.constants';
import { DropItem as DropItemSmall } from './play/interactive-response-categorise-small.constants';

export type ViewProps = Omit<
  ComponentInteractiveResponseCategorise,
  '__typename'
>;
export type EditProps = ViewProps;
export type SettingProps = EditProps & {
  contentId: number;
};

export type InteractiveResponseCategoriseProperties = GetActivitiesSections_getActivitiesSections_components_ActivitiesCategoriseResponseComponent_properties;
export type InteractiveResponseCategoriseItem = GetActivitiesSections_getActivitiesSections_components_ActivitiesCategoriseResponseComponent_properties_interactiveResponseCategorise_items;
export type InteractiveResponseCategoriesCategory = GetActivitiesSections_getActivitiesSections_components_ActivitiesCategoriseResponseComponent_properties_interactiveResponseCategorise_categories;

export type CategoryOption = {
  label: string;
  value: string;
};

export type InteractiveCategoriseAttempt = (dropItems: DropItem[]) => void;

export type InteractiveCategoriseSmallAttempt = (
  dropItems: DropItemSmall[]
) => void;

export const INITIAL_SETUP_DURATION = 600;

export const RESPONSE_FIXED = 'fixed';
export const RESPONSE_FREE = 'free';

export const CATEGORISE_DROP_ITEM_SIZE = 88;
